export default __webpack_public_path__ + "static/notosans-regular-webfont-0a49d9b849d9103afc6b370640aa30d0.woff2";